<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-2">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-6">
                  <span class="titulo bold">Proceso de Renovación</span>
                </div>
                <div
                  class="
                    col-6
                    fC
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                >
                  <span class="fC bold underlined"
                    >No. certificado:
                    <router-link :to="'/registro/' + id_registro">{{
                      data.no_certificado
                    }}</router-link></span
                  >
                </div>

                <div class="col-12 py-3">
                  <div class="pasos">
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 1, pasado: paso > 1 }"
                    >
                      <!-- <div class="numero">
                        <span>1</span>
                      </div> -->
                      <i class="icono fas fa-building fM"></i>
                      <div class="texto">
                        <span>Datos del contratante</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 2, pasado: paso > 2 }"
                    >
                      <!-- <div class="numero">
                        <span>2</span>
                      </div> -->
                      <i class="icono fas fa-file-alt fM"></i>
                      <div class="texto">
                        <span>Detalle de la póliza</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 3, pasado: paso > 3 }"
                    >
                      <!-- <div class="numero">
                        <span>3</span>
                      </div> -->
                      <i class="icono fas fa-user fM"></i>
                      <div class="texto">
                        <span>Datos del cliente</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 4, pasado: paso > 4 }"
                    >
                      <!-- <div class="numero">
                        <span>4</span>
                      </div> -->
                      <i class="icono fas fa-bicycle fM"></i>
                      <div class="texto">
                        <span>Datos de la bicicleta</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 5, pasado: paso > 5 }"
                    >
                      <!-- <div class="numero">
                        <span>5</span>
                      </div> -->
                      <i class="icono fas fa-shield-alt fM"></i>
                      <div class="texto">
                        <span>Cobertura</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="contenido">
                <form
                  class="row mx-3"
                  method="post"
                  @submit="submitFormulario($event)"
                >
                  <div
                    class="formulario col-12 bg-white shadow p-4 rounded card"
                  >
                    <div class="row" v-show="paso == 1">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Nombre de la compañía contratante</span>
                            <input
                              type="text"
                              v-model="form.contratante"
                              maxlength="100"
                              placeholder="Nombre de la compañía contratante"
                              required
                              readonly
                            />
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-show="paso == 2">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <div class="col-md-12 pb-2">
                            <label>
                              <span>Número de póliza</span>
                              <input
                                type="text"
                                v-model="form.no_poliza"
                                maxlength="100"
                                placeholder="No hay número de póliza vigente"
                                required
                                readonly
                              />
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Inicio de vigencia</span>
                              <input
                                type="datetime-local"
                                v-model="form.vigencia_ini"
                                maxlength="100"
                                placeholder="Clic para seleccionar"
                                @change="changeVigenciaIni()"
                                :min="minDate"
                                required
                              />
                            </label>
                          </div>
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Fin de vigencia</span>
                              <input
                                type="datetime-local"
                                v-model="form.vigencia_fin"
                                maxlength="100"
                                placeholder="Clic para seleccionar"
                                readonly
                                required
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-show="paso == 3">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <div class="col-12">
                            <label>
                              <input
                                type="checkbox"
                                v-model="form.usar_razon_social"
                                @change="razonSocialChange($event)"
                              />
                              <span>Usar razón social</span>
                            </label>
                          </div>
                          <div class="col-12 pb-2">
                            <label>
                              <input
                                type="text"
                                v-model="form.razon_social"
                                placeholder="Razón social"
                                :required="form.usar_razon_social"
                                :readonly="form.usar_razon_social == false"
                                @change="modCliente()"
                              />
                            </label>
                          </div>

                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Nombre(s)</span>
                              <input
                                type="text"
                                v-model="form.nombre"
                                maxlength="100"
                                placeholder="Nombre"
                                :required="form.usar_razon_social == false"
                                :readonly="form.usar_razon_social"
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Apellido Paterno</span>
                              <input
                                type="text"
                                v-model="form.apellido_paterno"
                                maxlength="100"
                                placeholder="Apellido paterno"
                                :required="form.usar_razon_social == false"
                                :readonly="form.usar_razon_social"
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Apellido materno</span>
                              <input
                                type="text"
                                v-model="form.apellido_materno"
                                maxlength="100"
                                placeholder="Apellido materno"
                                :required="form.usar_razon_social == false"
                                :readonly="form.usar_razon_social"
                                @change="modCliente()"
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>RFC</span>
                              <input
                                type="text"
                                v-model="form.rfc"
                                placeholder="RFC"
                                required
                                @change="modCliente()"
                              />
                            </label>
                          </div>

                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Correo Electrónico</span>
                              <input
                                type="text"
                                v-model="form.email"
                                maxlength="100"
                                placeholder="Correo Electrónico"
                                required
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Verificar Correo Electrónico</span>
                              <input
                                type="text"
                                v-model="form.email2"
                                maxlength="100"
                                placeholder="Verificar Correo Electrónico"
                                required
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Teléfono</span>
                              <input
                                type="text"
                                v-model="form.telefono"
                                maxlength="100"
                                placeholder="+52"
                                required
                                @change="modCliente()"
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Estado</span>
                              <select
                                v-model="form.estado"
                                @change="estadoChange($event)"
                                required
                              >
                                <option value="">Estado</option>
                                <option
                                  :value="estado.c_estado"
                                  v-for="estado in estados"
                                  v-bind:key="estado.c_estado"
                                >
                                  {{ estado.d_estado }}
                                </option>
                              </select>
                            </label>
                          </div>

                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Municipio / Delegación</span>
                              <select
                                v-model="form.municipio_o_del"
                                @change="municipioChange($event)"
                                required
                              >
                                <option value="">Municipio / Delegación</option>
                                <option
                                  :value="municipio.c_mnpio"
                                  v-for="municipio in municipios"
                                  v-bind:key="municipio.c_mnpio"
                                >
                                  {{ municipio.d_mnpio }}
                                </option>
                              </select>
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Colonia</span>
                              <select
                                v-model="form.colonia"
                                @change="coloniaChange($event)"
                                required
                              >
                                <option value="">Colonia</option>
                                <option
                                  :value="colonia.id_asenta_cpcons"
                                  v-for="colonia in colonias"
                                  v-bind:key="colonia.id_asenta_cpcons"
                                >
                                  {{ colonia.d_asenta }}
                                </option>
                              </select>
                            </label>
                          </div>
                          <div class="col-md-4 pb-2">
                            <label>
                              <span>Código Postal</span>
                              <input
                                type="text"
                                v-model="form.cp"
                                maxlength="5"
                                placeholder="CP"
                                required
                              />
                            </label>
                          </div>

                          <div class="col-md-8 pb-2">
                            <label>
                              <span>Calle</span>
                              <input
                                type="text"
                                v-model="form.calle"
                                maxlength="500"
                                placeholder="Calle"
                                required
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                          <div class="col-md-2 pb-2">
                            <label>
                              <span>No. Exterior</span>
                              <input
                                type="text"
                                v-model="form.no_ext"
                                maxlength="100"
                                placeholder="No. Ext"
                                required
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                          <div class="col-md-2 pb-2">
                            <label>
                              <span>No. Interior</span>
                              <input
                                type="text"
                                v-model="form.no_int"
                                maxlength="100"
                                placeholder="No. Int"
                                @change="modCliente()"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-show="paso == 4">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Marca</span>
                              <input
                                type="text"
                                v-model="form.marca"
                                maxlength="100"
                                placeholder="Marca"
                                required
                                @change="modBici()"
                              />
                            </label>
                          </div>
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Modelo</span>
                              <input
                                type="text"
                                v-model="form.modelo"
                                maxlength="100"
                                placeholder="Modelo"
                                required
                                @change="modBici()"
                              />
                            </label>
                          </div>
                          <div class="col-12 pb-2">
                            <label>
                              <span>No. de serie</span>
                              <input
                                type="text"
                                v-model="form.no_serie"
                                maxlength="100"
                                placeholder="No. de serie"
                                required
                                @change="modBici()"
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Equipamiento Adicional</span>
                              <textarea
                                v-model="form.equipamiento_adicional"
                                class="w-100"
                                rows="4"
                                @change="modBici()"
                              ></textarea>
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Descripción</span>
                              <textarea
                                v-model="form.descripcion"
                                class="w-100"
                                rows="4"
                                required
                                @change="modBici()"
                              ></textarea>
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Valor Factura</span>
                              <input
                                type="number"
                                v-model="form.valor_factura"
                                placeholder="$"
                                @change="modBici()"
                              />
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Año</span>
                              <input
                                type="number"
                                v-model="form.ano"
                                min="1111"
                                max="9999"
                                placeholder="Año"
                                required
                                @change="modBici()"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row resumen py-4" v-show="paso == 5">
                      <div class="col-12 pb-2 fC small">
                        Suma asegurada: ${{ form.valor_factura }}
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round">
                          <div>
                            <div>PRIMA NETA</div>
                            <div class="bold fG">${{ form.prima_neta }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round">
                          <div>
                            <div>DERECHOS DE PÓLIZA</div>
                            <div class="bold fG">
                              ${{ form.derecho_de_poliza }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round">
                          <div>
                            <div>IVA</div>
                            <div class="bold fG">${{ form.iva }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 text-center pb-4">
                        <div class="card border-round">
                          <div>
                            <div>PRIMA TOTAL</div>
                            <div class="bold fG">${{ form.prima_total }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round">
                          <div>
                            <div>COBERTURA BÁSICA</div>
                            <div class="bold fR px-5 py-2">
                              Deducible: {{ form.cobertura_basica }}% del valor de la bicicleta
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center">
                        <div class="card border-round">
                          <div>
                            <div>ROBO CON VIOLENCIA</div>
                            <div class="bold fR px-5 py-2">
                              Deducible: 10% del valor de la bicicleta
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center">
                        <div class="card border-round">
                          <div>
                            <div>RESPONSABILIDAD CIVIL</div>
                            <div class="bold fR px-5 py-2">
                              Deducible: 10% de la pérdida con mínimo de 50 UMAS
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div
                          class="text-center pt-2 float-left"
                          v-show="paso > 1"
                        >
                          <button
                            type="button"
                            class="submit btnnaranja"
                            @click="regresar()"
                          >
                            REGRESAR
                          </button>
                        </div>
                        <div
                          class="text-center pt-2 float-right"
                          v-show="paso < 5"
                        >
                          <button
                            type="button"
                            class="submit btnnaranja"
                            @click="continuar()"
                          >
                            CONTINUAR
                          </button>
                        </div>
                        <div
                          class="text-center pt-2 float-right"
                          v-show="paso == 5"
                        >
                          <button
                            type="button"
                            @click="submitFormulario()"
                            class="submit btnnaranja"
                          >
                            FINALIZAR
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      endosos: [],
      minDate: null,
      fechaCaducidadPoliza: null,
      paso: 1,
      id_registro: "",
      cobertura_basica: null,
      modificacion_datos_cliente: false,
      modificacion_datos_bicicleta: false,
      form: {
        admin_id: "",
        contratante: "",
        no_poliza: "",
        no_certificado: "",
        vigencia_ini: "",
        vigencia_fin: "",
        usar_razon_social: false,
        razon_social: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        rfc: "",
        email: "",
        email2: "",
        telefono: "",
        ciudad: "",
        municipio_o_del: "",
        colonia: "",
        cp: "",
        calle: "",
        no_ext: "",
        no_int: "",
        descripcion: "",
        marca: "",
        modelo: "",
        no_serie: "",
        equipamiento_adicional: "",
        valor_factura: "",
        ano: "",
        prima_neta: "",
        derecho_de_poliza: "",
        iva: "",
        prima_total: "",
        cobertura_basica: "",
        robo_con_violencia: "",
        responsabilidad_civil: "",
        fecha_posterior: ""
      },
      tiposervicio: "",
      columns: [
        "nombre",
        "email",
        "no_poliza",
        "no_certificado",
        "uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));

    AOS.init();

    this.id_registro = this.$route.params.id;

    this.consulta();
    this.getCoberturaBasica();
  },
  methods: {
    modCliente(){
      this.modificacion_datos_cliente = true;
    },
    modBici(){
      this.modificacion_datos_bicicleta = true;
    },
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id: this.id_registro,
        admin_id: this.$store.state.user.admin_id,
        user_id: this.$store.state.user.id,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];


              this.form.contratante = this.data.contratante;

              //revisar la fecha de caducidad de poliza
              //si la fecha de caducidad de poliza es mayor a la fecha de hoy
              //asignar fecha vigencia_ini al valor de hoy

              let hoy_formatted = new Date();
              hoy_formatted = this.formatDate(hoy_formatted) + "T12:00";
              let hoy = new Date(hoy_formatted);
              let terminoVigencia = new Date(this.data.vigencia_fin);
              console.log({hoy});

              console.log({terminoVigencia});

              if (moment(hoy).isAfter(terminoVigencia)) {
                this.form.vigencia_ini = hoy_formatted;
                this.form.fecha_posterior = "si";
              }else{
                //la fecha de vigencia_fin de la poliza es menor a la fecha de hoy
                this.form.vigencia_ini = this.data.vigencia_fin
                .toString()
                .replace(" ", "T");
                this.form.fecha_posterior = "no";
              }

              

              this.changeVigenciaIni();

              this.minDate = new Date(this.form.vigencia_ini);
              this.minDate.setFullYear(this.minDate.getFullYear() + 1);
              this.minDate = this.minDate.toISOString();
              this.minDate = this.minDate.substring(0, this.minDate.length - 1);

              


              //admin id para renovacion
              this.form.admin_id = this.data.admin_id;
              console.log({admin_id_renovacion: this.form.admin_id})

              if(this.data.usar_razon_social == 0){
                this.form.usar_razon_social = false;
              }else{
                this.form.usar_razon_social = true;
              }
              
              this.form.razon_social = this.data.razon_social;
              this.form.nombre = this.data.nombre;
              this.form.apellido_paterno = this.data.apellido_paterno;
              this.form.apellido_materno = this.data.apellido_materno;
              this.form.rfc = this.data.rfc;
              this.form.email = this.data.email;
              this.form.email2 = this.data.email;
              this.form.telefono = this.data.telefono;
              this.form.ciudad = this.data.ciudad;
              this.form.municipio_o_del = this.data.municipio_o_del;
              this.form.colonia = this.data.colonia;
              this.form.cp = this.data.cp;
              this.form.calle = this.data.calle;
              this.form.no_ext = this.data.no_ext;
              this.form.no_int = this.data.no_int;
              this.form.marca = this.data.marca;
              this.form.modelo = this.data.modelo;
              this.form.no_serie = this.data.no_serie;
              this.form.equipamiento_adicional = this.data.equipamiento_adicional;
              this.form.valor_factura = this.data.valor_factura;
              this.form.ano = this.data.ano;
              this.form.prima_neta = this.data.prima_neta;
              this.form.derecho_de_poliza = this.data.derecho_de_poliza;
              this.form.iva = this.data.iva;
              this.form.prima_total = this.data.prima_total;
              this.form.descripcion = this.data.descripcion;

              this.endosos = res.endosos;
              this.calculaValorFacturaEndosos();

              //this.minDate = "2022-10-15T11:06";

              this.consultaEstados();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    calculaValorFacturaEndosos() {
      console.log("calculaValorFacturaEndoso");
      console.log({ endosos: this.endosos });

      if (this.endosos.length > 0) {
        console.log("recalculando valor factura");


        let suma = this.form.valor_factura;
        let cadena = "";

        if (this.form.equipamiento_adicional == "Sin equipamiento")
          this.form.equipamiento_adicional = "";

        this.endosos.forEach((endoso) => {
          suma = suma + endoso.valor_factura;
          cadena = cadena + endoso.equipamiento_adicional + ', ';
        });

        cadena = cadena.substring(0, cadena.length - 2);

        this.form.valor_factura = suma;
        this.form.equipamiento_adicional = cadena;
      }
    },
    consultaEstados() {
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-estados.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.estados = res.datos;
              console.log({ estados: this.estados });

              this.form.estado = this.data.estado;
              this.consultaMunicipio();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );
    },
    estadoChange(e) {

      this.modificacion_datos_cliente = true;


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-municipios.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.municipios = res.datos;
              this.form.municipio_o_del = "";
              this.form.colonia = "";
              this.form.cp = "";
              console.log({ mnpios: this.municipios });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );
    },
    consultaMunicipio() {
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-municipios.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.municipios = res.datos;
              console.log({ mnpios: this.municipios });

              this.form.municipio_o_del = this.data.municipio_o_del;
              this.consultaColonias();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );
    },
    municipioChange(e = null) {

      this.modificacion_datos_cliente = true;

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-colonias.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.colonias = res.datos;
              this.form.colonia = "";
              this.form.cp = "";
              console.log({ colonias: this.colonias });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );
    },
    consultaColonias(e = null) {
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-colonias.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.colonias = res.datos;
              console.log({ colonias: this.colonias });

              this.form.colonia = this.data.colonia;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );
    },
    coloniaChange(e = null) {

      this.modificacion_datos_cliente = true;


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del,
        id_asenta_cpcons: this.form.colonia,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-cp.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.cp = res.datos[0].d_codigo;
              console.log({ cp: this.form.cp });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );
    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.rfc = "";
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {

      let thes = this;

      if (this.validaPaso(this.paso) == false) {
        swal.fire(
          "Datos faltantes",
          "Por favor llena todos los campos del formulario antes de continuar.",
          "warning"
        );
        return;
      }


      //popups
      if(this.paso == 3){
        if(this.modificacion_datos_cliente){
          swal
          .fire({
            title: "Modificación de datos",
            html: "¿Los datos del cliente son correctos?",
            confirmButtonText: `Ok`,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              thes.paso = 4;
              thes.modificacion_datos_cliente = false;
              thes.continuarSegundaParte();
            }
          });
        }else{
          this.paso = 4;
          this.continuarSegundaParte();
        }
      }else if(this.paso == 4){
        if(this.modificacion_datos_bicicleta){
          swal
          .fire({
            title: "Modificación de datos",
            html: "¿Los datos de la bicicleta son correctos?",
            confirmButtonText: `Ok`,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              thes.paso = 5;
              thes.modificacion_datos_bicicleta = false;
              thes.continuarSegundaParte();
            }
          });
        }else{
          this.paso = 5;
          this.continuarSegundaParte();
        }
      }else{
        this.paso++;
        this.continuarSegundaParte();
      }

      
    },
    continuarSegundaParte(){


      if (this.paso == 2) {
        this.getNoPolizaVigente();
      }

      if (this.paso == 5) {
        //calcular prima, iva, etc
        let valor_factura = this.form.valor_factura;
        let prima_neta = 0;
        if (valor_factura > 0) {
          //calcular prima neta
          if (valor_factura <= 50000) {
            this.form.prima_neta = 862.06;
          } else if (valor_factura <= 100000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.052).toFixed(2);
          } else if (valor_factura <= 300000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          } else {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          }

          //calcular derechos de poliza
          // // if (this.form.prima_neta <= 1000) {
          // //   this.form.derecho_de_poliza = 125.0;
          // // } else if (this.form.prima_neta <= 5000) {
          // //   this.form.derecho_de_poliza = 250.0;
          // // } else if (this.form.prima_neta <= 10000) {
          // //   this.form.derecho_de_poliza = 325.0;
          // // } else if (this.form.prima_neta <= 30000) {
          // //   this.form.derecho_de_poliza = 500.0;
          // // } else {
          // //   this.form.derecho_de_poliza = 700.0;
          // // }

          this.form.derecho_de_poliza = 0;

          //calcular iva
          this.form.iva = parseFloat(
            (parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza)) *
              0.16
          ).toFixed(2);
          this.form.prima_total = parseFloat(
            parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza) +
              parseFloat(this.form.iva)
          ).toFixed(2);
        }
      }


    },
    getNoPolizaVigente() {
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData.user_email = this.$store.state.user.user_email;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "get-no-poliza-vigente-renovacion.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.form.no_poliza = res.no_poliza;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    regresar() {
      this.paso--;
    },
    validaPaso(paso) {
      var flag = false;

      if (paso == 1) {
        if (this.form.contratante != "") {
          flag = true;
        }
      } else if (paso == 2) {
        if (
          this.form.no_poliza != "" &&
          this.form.vigencia_ini != "" &&
          this.form.vigencia_fin != ""
        ) {
          flag = true;
        }
      } else if (paso == 3) {
        if (
          this.form.rfc != "" &&
          this.form.email != "" &&
          this.form.email2 != "" &&
          this.form.telefono != "" &&
          this.form.estado != "" &&
          this.form.municipio_o_del != "" &&
          this.form.colonia != "" &&
          this.form.cp != "" &&
          this.form.calle != "" &&
          this.form.no_ext != ""
        ) {
          flag = true;
        }

        if (this.form.usar_razon_social == true) {
          if (this.form.razon_social == "") {
            flag = false;
          }
        } else {
          if (
            this.form.nombre == "" ||
            this.form.apellido_paterno == "" ||
            this.form.apellido_materno == ""
          ) {
            flag = false;
          }
        }
      } else if (paso == 4) {
        if (
          this.form.descripcion != "" &&
          this.form.marca != "" &&
          this.form.modelo != "" &&
          this.form.no_serie != "" &&
          this.form.equipamiento_adicional != "" &&
          this.form.valor_factura != "" &&
          this.form.ano != ""
        ) {
          flag = true;
        }

        
      }

      return flag;
    },
    submitFormulario(e) {
      //terminar
      console.log("submit renvoacion");
      //e.preventDefault();

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;
      qData.user_email = this.$store.state.user.user_email;
      qData.admin_id = this.form.admin_id;
      

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "alta-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              swal
                .fire({
                  title: "Registro",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push("/dashboard");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    changeVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date(this.form.vigencia_ini);
      date.setFullYear(date.getFullYear() + 1);

      let hoy = new Date();
      if (moment(hoy).isAfter(date, "day")) {
        swal.fire("Oops", "Fecha inválida.", "warning");
        return;
      }

      this.form.vigencia_fin = this.formatDate(date) + "T12:00";

      //console.log(this.form.vigencia_fin);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;

      return [hour, minute].join(":");
    },
    getCoberturaBasica() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        admin_id: this.$store.state.user.admin_id,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "get-cobertura-basica.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.cobertura_basica = res.cobertura_basica;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

